<template>
    <div class="list-warpper">
        <div class="search-container flex flex-direction align-center justify-center">
            <img alt="" class="logo" src="../../../assets/img/h5-logo.png"/>
            <div class="search flex align-center justify-center">
                <i class="el-icon-search"></i>
                <form action="javascript:void 0" title="搜索">
                    <input v-model="search_vague_keywords" class="search-input"
                           placeholder="请输入关键词进行搜索" type="search" @keyup.13="onRefresh"/>
                </form>
            </div>
        </div>
        <van-dropdown-menu>
            <van-dropdown-item v-model="search_is_pay" :options="payList" title="缴费状态"/>
            <van-dropdown-item v-model="search_state" :options="applyList" title="证书情况"/>
            <van-dropdown-item v-model="search_register_address_county" :options="addressList" title="所在地区"/>
        </van-dropdown-menu>
        <van-pull-refresh v-model="refreshing" class="list" @refresh="onRefresh">
            <van-list
                :finished="finished"
                v-model="loading"
                finished-text="没有更多了"
                @load="onLoad">
                <router-link :to="`/mobile/admin/member/detail?id=${item.id}`" class="item flex flex-direction" v-for="(item,index) in list" :key="index">
                    <div class="title">{{item.company_name}}</div>
                    <div class="content">法人姓名：{{item.legal_person_name}}</div>
                    <div class="content">供需分类：{{item.member_type_text}}</div>
                    <div class="flex align-center justify-between">
                        <div class="content">联 系 人：{{item.tel_name}}</div>
                        <div class="content">联系电话：{{item.tel_number}}</div>
                    </div>
                    <div class="bottom flex align-center justify-between">
                        <div class="flex align-center">
                            <div v-if="item.pay_style_text" class="tag  flex align-center"
                            :class="{green:item.pay_style === 2,red:item.pay_style===1}">
                                <van-icon  class="icon" :class="{green:item.pay_style === 2,red:item.pay_style===1}" name="balance-o" />
                                <div class="flex-sub text-center">{{item.pay_style_text}}</div>
                            </div>
                             <div class="tag text-center">
                                 {{ item.company_level_id | level }}
                            </div>

                        </div>
                        <div class="number">证书编号：{{item.cert_number}}</div>
                    </div>
                </router-link>
            </van-list>
        </van-pull-refresh>
    </div>
</template>

<script>
import {address, applyList, filesCN, formatList, formatListValue, level, payList} from "@/utils/utils";
import {getMemberList} from "@/api/admin";

export default {
    name: "list",
    data() {
        return {
            payList: formatList(payList),
            applyList: formatList(applyList),
            addressList: formatListValue(formatList(address)),
            refreshing: false,
            loading: false,
            finished: false,
            list: [],
            search_vague_keywords:'',
            search_is_pay:'',
            search_register_address_county:'',
            search_state:'',
            page:1,
            limit:10
        }
    },
    computed: {},
    components: {},
    created() {
    },
    mounted() {

    },
    methods: {
        async init(){
          let _data = await getMemberList(this.search_vague_keywords,this.search_is_pay,this.search_register_address_county,
          this.search_state,this.page,this.limit)
            if (this.page === 1){
                this.list = _data.data
            }else {
                this.list = [...this.list ,..._data.data]
            }
            if (_data.total > this.list.length){
                this.page++
            }else {
                this.finished = true
            }
            this.refreshing =false
            this.loading =false

        },
        onRefresh() {
            this.refreshing = true
            this.finished = false
            this.page = 1
            this.init()
        },
        onLoad() {
            this.loading = true
            this.init()
        }
    },
    filters: {
        level(val) {
            return filesCN(Number(val), level)
        }
    },
    watch:{
        search_is_pay(){
            this.onRefresh()
        },
        search_register_address_county(){
            this.onRefresh()
        },
        search_state(){
            this.onRefresh()
        }
    }
}
</script>

<style lang="scss" scoped>
.list-warpper {
    display: flex;
    flex-direction: column;
    min-height: 100vh;

    .search-container {
        width: 100%;
        background: url(../../../assets/img/h5-bg.png) no-repeat top;
        background-size: 100% auto;
        height: 200px;

        .logo {
            width: 80%;
        }

        .search {
            width: 345px;
            height: 40px;
            background-color: transparent;
            border-radius: 20px;
            margin-top: 20px;
            padding: 0 20px;
            border: solid 1px #ffffff;
            color: #FFFFFF;

            .search-input {
                min-width: 60%;
                background-color: transparent;
                margin-left: 10px;
                -webkit-appearance: none;

                &:focus {
                    color: #FFFFFF;
                }

                &::placeholder {
                    color: #FFFFFF;
                }
            }
        }

    }

    .list {
        background: #f1f1f1;
        flex: 1;

        .item {
            background-color: #ffffff;
            border-radius: 8px;
            margin: 15px 15px 0;
            padding: 15px;

            .title {
                font-size: 16px;
                line-height: 26px;
                color: #333333;
                font-weight: bold;
            }

            .content {
                font-size: 12px;
                color: #666666;
                margin-top: 10px;
            }

            .number{
                font-size: 12px;
                color: #666666;
            }
            .bottom {
                border-top: 1px solid #e4e4e4;
                padding-top: 15px;
                margin-top: 10px;
                .tag {
                    min-width: 70px;
                    height: 20px;
                    line-height: 20px;
                    background-color: #ffffff;
                    border-radius: 2px;
                    border: solid 1px #0d7fd7;
                    font-size: 12px;
                    color: #0d7fd7;
                    margin-right: 8px;
                    &.green {
                        color: #2ac191;
                        border: solid 1px #2ac191;
                    }

                    &.red {
                        color: #f26060;
                        border: solid 1px #f26060;
                    }

                    .icon {
                        width: 20px;
                        height: 20px;
                        text-align: center;
                        line-height: 20px;
                        background: #0d7fd7;
                        color: #FFFFFF;
                        &.green {
                            background: #2ac191;
                        }

                        &.red {
                            color: #FFFFFF!important;
                            background: #f26060;
                        }
                    }
                }
            }

        }
    }

}
</style>